const VIEW_SIZES = {
    SMALL: 's',
    MEDIUM: 'm',
    LARGE: 'l'
}

export { VIEW_SIZES }
export { default } from './useViewSize'